import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography } from "@material-tailwind/react";
import ShowLoader from "@/components/Loader"; // Adjust path as needed
import { fetchPolicy } from "@/store/slices/policySlice"; // Adjust path as needed

export function PublicPolicy({ type }) {
  const dispatch = useDispatch();
  
  const selectedPolicy = useSelector((state) => state.policy.selected);
  const { loading } = useSelector((state) => state.policy);

  useEffect(() => {
    dispatch(fetchPolicy(type));
  }, [dispatch, type]);

  // If loading, show the loader
  if (loading) {
    return (
      <div className="min-h-[60vh] flex justify-center items-center">
        <ShowLoader />
      </div>
    );
  }

  // If no content is found (and not loading)
  if (!selectedPolicy || (!selectedPolicy.title && !selectedPolicy.content)) {
    return (
      <div className="min-h-[60vh] flex flex-col justify-center items-center px-4">
        <Typography variant="h3" color="blue-gray" className="mb-2 text-center">
          Page Not Found
        </Typography>
        <Typography color="gray" className="text-center">
          The content you are looking for is not available at the moment.
        </Typography>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen bg-white">
      <div className="max-w-5xl mx-auto relative z-10">
        {/* Header Section */}
        <div className="border-b border-gray-100 pb-8 mb-8 text-center">
          <Typography variant="h2" color="blue-gray" className="font-bold">
            {selectedPolicy.title}
          </Typography>
          {/* {selectedPolicy.updated_at && (
            <Typography variant="small" color="gray" className="mt-4 font-medium">
              Last Updated: {new Date(selectedPolicy.updated_at).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </Typography>
          )} */}
        </div>

        {/* Content Section */}
        {/* Note: We use specific utility classes here to ensure the injected HTML styles nicely. 
            If you have @tailwindcss/typography installed, you can replace the className below with "prose max-w-none" */}
        <div 
          className="text-gray-700 leading-relaxed space-y-6 [&>h1]:text-3xl [&>h1]:font-bold [&>h1]:mb-4 [&>h2]:text-2xl [&>h2]:font-bold [&>h2]:mt-8 [&>h2]:mb-4 [&>h3]:text-xl [&>h3]:font-bold [&>h3]:mt-6 [&>h3]:mb-3 [&>p]:mb-4 [&>ul]:list-disc [&>ul]:pl-5 [&>ul]:mb-4 [&>ol]:list-decimal [&>ol]:pl-5 [&>ol]:mb-4 [&>a]:text-blue-600 [&>a]:underline"
          dangerouslySetInnerHTML={{ __html: selectedPolicy.content }} 
        />
        
      </div>
    </div>
  );
}

export default PublicPolicy;